import { defineMessages } from 'react-intl';

export const appearanceModeMessages = defineMessages({
  light: {
    defaultMessage: 'Light',
    id: 'tcX5IEQYVX',
    description: 'Appearance mode option that forces the light theme',
  },
  dark: {
    defaultMessage: 'Dark',
    id: 'M0gzSB4jh/',
    description: 'Appearance mode option that forces the dark theme',
  },
  system: {
    defaultMessage: 'Match system preference',
    id: '9A08RmwSub',
    description: 'Appearance mode option that follows the OS light/dark setting',
  },
});
